import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toggleStepsList, toggleResponsesList, selectResponse, selectStep, selectMode, selectFeature } from '../actions/commonActions'
import { _MCP } from '../actions/types'
import Indicator from '../components/common/Indicator'
import StepsList from '../components/common/StepsList'
import StepsMenu from '../components/common/StepsMenu'
import ResponseList from '../components/common/ResponseList'
import { FEATURES } from '../constants/common/Features'
import responses from '../constants/mcp/responses'
import Response from '../components/common/Response'
import AboutMCP from '../components/mcp/steps/AboutMCP'
import MethodsOfMCP from '../components/mcp/steps/MethodsOfMCP'
import GetRate from '../components/mcp/steps/GetRate'
import Purchase from '../components/mcp/steps/Purchase'
import PreAuth from '../components/mcp/steps/PreAuth'
import PreAuthCompletion from '../components/mcp/steps/PreAuthCompletion'
import PurchaseCorrection from '../components/mcp/steps/PurchaseCorrection'
import Refund from '../components/mcp/steps/Refund'
import IndependentRefund from '../components/mcp/steps/IndependentRefund'
import PurchaseWithVault from '../components/mcp/steps/PurchaseWithVault'
import PreAuthWithVault from '../components/mcp/steps/PreAuthWithVault'
import IndRefundWithVault from '../components/mcp/steps/IndRefundWithVault'
import CurrencyCodes from '../components/mcp/steps/CurrencyCodes'
import ErrorCodes from '../components/mcp/steps/ErrorCodes'
import TestCards from '../components/mcp/steps/TestCards'
import PurchaseWith3DS from '../components/mcp/steps/PurchaseWith3DS'
import PurchaseWith3DSVault from '../components/mcp/steps/PurchaseWith3DSVault'
import PreAuthWith3DS from '../components/mcp/steps/PreAuthWith3DS'
import PreAuth3DSVault from '../components/mcp/steps/PreAuth3DSVault'
import Configuration from '../components/mcp/steps/Configuration'
import Footer from '../components/common/Footer'

var isIE = /*@cc_on!@*/false || !!document.documentMode;
var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

const scrollToRef = (ref) => {ref.current.scrollIntoView({behavior: "smooth"})}

export class MCPPage extends Component {
    state = {
        ref1: React.createRef(),
        ref2: React.createRef(),
        ref3: React.createRef(),
        ref4: React.createRef(),
        ref5: React.createRef(),
        ref6: React.createRef(),
        ref7: React.createRef(),
        ref8: React.createRef(),
        ref9: React.createRef(),
        ref10: React.createRef(),
        ref11: React.createRef(),
        ref12: React.createRef(),
        ref13: React.createRef(),
        ref14: React.createRef(),
        ref15: React.createRef(),
        ref16: React.createRef(),
        ref17: React.createRef(),
        ref18: React.createRef(),
        ref19: React.createRef()
    }

    componentDidMount() {        
        if(this.props.mode === "integration_guide")
            this.scrollIntoStep(this.props.selectedStep);

        document.title = 'MCP | Moneris Developers';
    }

    componentDidUpdate(prevProps) {
        const { selectedStep, mode } = this.props;

        if(mode !== prevProps.mode && mode === 'integration_guide') {
            this.scrollIntoStep(selectedStep)
        }
    }

    isInViewport(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
    }

    justLeft(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        const diff = (top - offset) - window.innerHeight;
        return (top + offset) >= 0 && diff > 0 && diff < 100;
    }

    handleScrolling() {
        const { ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10,
                ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19 } = this.state
        const { selectStep } = this.props

        // console.log(window.pageYOffset);

        if(this.isInViewport(ref1.current) || this.justLeft(ref2.current)) {
            selectStep({stepId: 1, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref2.current) || this.justLeft(ref3.current)) {
            selectStep({stepId: 2, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref3.current) || this.justLeft(ref4.current)) {
            selectStep({stepId: 3, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref4.current) || this.justLeft(ref5.current)) {
            selectStep({stepId: 4, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref5.current) || this.justLeft(ref6.current)) {
            selectStep({stepId: 5, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref6.current) || this.justLeft(ref7.current)) {
            selectStep({stepId: 6, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref7.current) || this.justLeft(ref8.current)) {
            selectStep({stepId: 7, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref8.current) || this.justLeft(ref9.current)) {
            selectStep({stepId: 8, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref9.current) || this.justLeft(ref10.current)) {
            selectStep({stepId: 9, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref10.current) || this.justLeft(ref11.current)) {
            selectStep({stepId: 10, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref11.current) || this.justLeft(ref12.current)) {
            selectStep({stepId: 11, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref12.current) || this.justLeft(ref13.current)) {
            selectStep({stepId: 12, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref13.current) || this.justLeft(ref14.current)) {
            selectStep({stepId: 13, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref14.current) || this.justLeft(ref15.current)) {
            selectStep({stepId: 14, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref15.current) || this.justLeft(ref16.current)) {
            selectStep({stepId: 15, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref16.current) || this.justLeft(ref17.current)) {
            selectStep({stepId: 16, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref17.current) || this.justLeft(ref18.current)) {
            selectStep({stepId: 17, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref18.current) || this.justLeft(ref19.current)) {
            selectStep({stepId: 18, featureId: _MCP});
            return
        }
        if(this.isInViewport(ref19.current)) {
            selectStep({stepId: 19, featureId: _MCP});
            return
        }
    }

    scrollIntoStep(stepId) {
        switch(stepId) {
            case 1:
                scrollToRef(this.state.ref1)
                break
            case 2:
                scrollToRef(this.state.ref2)
                break
            case 3:
                scrollToRef(this.state.ref3)
                break
            case 4:
                scrollToRef(this.state.ref4)
                break
            case 5:
                scrollToRef(this.state.ref5)
                break
            case 6:
                scrollToRef(this.state.ref6)
                break
            case 7:
                scrollToRef(this.state.ref7)
                break
            case 8:
                scrollToRef(this.state.ref8)
                break
            case 9:
                scrollToRef(this.state.ref9)
                break
            case 10:
                scrollToRef(this.state.ref10)
                break
            case 11:
                scrollToRef(this.state.ref11)
                break
            case 12:
                scrollToRef(this.state.ref12)
                break
            case 13:
                scrollToRef(this.state.ref13)
                break
            case 14:
                scrollToRef(this.state.ref14)
                break
            case 15:
                scrollToRef(this.state.ref15)
                break
            case 16:
                scrollToRef(this.state.ref16)
                break
            case 17:
                scrollToRef(this.state.ref17)
                break
            case 18:
                scrollToRef(this.state.ref18)
                break
            case 19:
                scrollToRef(this.state.ref19)
                break

            default:
                scrollToRef(this.state.ref1)
                break
        }
    }

    renderStepsContent() {
        if(this.props.mode === 'integration_guide') {
            return (
                <div className='pageContents'>
                    <div className='stepsContainer'>
                        <span ref={this.state.ref1}></span>
                        <AboutMCP />
                        <span ref={this.state.ref2}></span>
                        <MethodsOfMCP />
                        <span ref={this.state.ref3}></span>
                        <GetRate />
                        <span ref={this.state.ref4}></span>
                        <Purchase />
                        <span ref={this.state.ref5}></span>
                        <PurchaseWith3DS />
                        <span ref={this.state.ref6}></span>
                        <PurchaseWithVault />
                        <span ref={this.state.ref7}></span>
                        <PurchaseWith3DSVault />
                        <span ref={this.state.ref8}></span>
                        <PreAuth />
                        <span ref={this.state.ref9}></span>
                        <PreAuthWith3DS />
                        <span ref={this.state.ref10}></span>
                        <PreAuthWithVault />
                        <span ref={this.state.ref11}></span>
                        <PreAuth3DSVault />
                        <span ref={this.state.ref12}></span>
                        <PreAuthCompletion />
                        <span ref={this.state.ref13}></span>
                        <PurchaseCorrection />
                        <span ref={this.state.ref14}></span>
                        <Refund />
                        <span ref={this.state.ref15}></span>
                        <IndependentRefund />
                        <span ref={this.state.ref16}></span>
                        <IndRefundWithVault />
                        <span ref={this.state.ref17}></span>
                        <CurrencyCodes />
                        <span ref={this.state.ref18}></span>
                        <ErrorCodes />
                        <span ref={this.state.ref19}></span>
                        <TestCards />
                    </div>
                    <Footer />
                </div>
            );
        }
        else {
            switch(this.props.selectedStep) {
                case 3:
                    return <GetRate />
                case 4:
                    return <Purchase />
                case 5:
                    return <PurchaseWith3DS />
                case 6:
                    return <PurchaseWithVault />
                case 7:
                    return <PurchaseWith3DSVault />
                case 8:
                    return <PreAuth />
                case 9:
                    return <PreAuthWith3DS />
                case 10:
                    return <PreAuthWithVault />
                case 11:
                    return <PreAuth3DSVault />
                case 12:
                    return <PreAuthCompletion />
                case 13:
                    return <PurchaseCorrection />
                case 14:
                    return <Refund />
                case 15:
                    return <IndependentRefund />
                case 16:
                    return <IndRefundWithVault />
                default:
                    return null
            }
        }
    }


    renderResponseContent() {
        const { selectedResponse, loading, purchaseResponse, preAuthResponse, preAuthCompResponse, 
                getRateResponse, purchaseCorrectionResponse, refundResponse, independentRefundResponse,
                purchaseWithVaultResponse, preAuthWithVaultResponse, indRefundWithVaultResponse,
                purchase3dsResponse, purchase3dsVaultResponse, preAuth3dsResponse, preAuth3dsVaultResponse
            } = this.props;

        switch(selectedResponse) {
            case 3:
                return <Response title="Get Rate Output" output={getRateResponse} loading={loading} />
            case 4:
                return <Response title="MCP Purchase Output" output={purchaseResponse} loading={loading}/>
            case 5:
                return <Response title="MCP Purchase with 3DS Output" output={purchase3dsResponse} loading={loading}/>
            case 6:
                return <Response title="MCP Purchase with Vault Output" output={purchaseWithVaultResponse} loading={loading} />
            case 7:
                return <Response title="MCP Purchase with 3DS and Vault Output" output={purchase3dsVaultResponse} loading={loading}/>
            case 8:
                return <Response title="MCP Pre-Authorization Output" output={preAuthResponse} loading={loading} />
            case 9:
                return <Response title="MCP Pre-Auth with 3DS Output" output={preAuth3dsResponse} loading={loading} />
            case 10:
                return <Response title="MCP Pre-Auth with Vault Output" output={preAuthWithVaultResponse} loading={loading} />
            case 11:
                return <Response title="MCP Pre-Auth with 3DS and Vault Output" output={preAuth3dsVaultResponse} loading={loading} />
            case 12:
                return <Response title="MCP Pre-Auth Completion Output" output={preAuthCompResponse} loading={loading} />
            case 13:
                return <Response title="MCP Purchase Correction Output" output={purchaseCorrectionResponse} loading={loading} />
            case 14:
                return <Response title="MCP Refund Output" output={refundResponse} loading={loading} />
            case 15:
                return <Response title="MCP Independent Refund Output" output={independentRefundResponse} loading={loading} />
            case 16:
                return <Response title="MCP Independent Refund with Vault Output" output={indRefundWithVaultResponse} loading={loading} />
            
            default:
                return null
        }
    }

    renderNextSteps() {
        const { selectedResponse, prevSuccStep, getRateSuccess, preAuthSuccess, preAuthCompSuccess, purchaseSuccess, purchase3dsSuccess, purchaseWithVaultSuccess, purchase3dsVaultSuccess, mcpErrorCode } = this.props;

        if(!getRateSuccess && ![3, 12, 13].includes(selectedResponse) && mcpErrorCode === 1015) {
           return (
            <div className='sugestedNextSteps' style={{marginLeft: '25px', marginTop: '10px'}}>
                <h3 style={{marginTop: '0'}}>Required Transaction:</h3>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center' }}>
                    <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 3, featureId: _MCP})}>MCP Get Rate</span>
                </div>
            </div>
           );
        }

        if(prevSuccStep === selectedResponse && selectedResponse === 3 && getRateSuccess) {
            return (
                <div className='suggestedNextSteps'>
                    <span>Suggested Next Steps:</span>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '10px' }}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 4, featureId: _MCP})}>Purchase</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 6, featureId: _MCP})}>Purchase with Vault</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 8, featureId: _MCP})}>Pre-Auth</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 10, featureId: _MCP})}>Pre-Auth with Vault</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '10px' }}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 5, featureId: _MCP})}>Purchase with 3DS</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 7, featureId: _MCP})}>{"Purchase with 3DS & Vault"}</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 9, featureId: _MCP})}>Pre-Auth with 3DS</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '10px' }}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 11, featureId: _MCP})}>{"Pre-Auth with 3DS & Vault"}</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 15, featureId: _MCP})}>Independent Refund</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 16, featureId: _MCP})}>Independent Refund with Vault</span>
                    </div>
                </div>
            );
        }

        if(prevSuccStep === selectedResponse && ((selectedResponse === 4 && purchaseSuccess) || (selectedResponse === 5 && purchase3dsSuccess) || (selectedResponse === 6 && purchaseWithVaultSuccess) || (selectedResponse === 7 && purchase3dsVaultSuccess) || (selectedResponse === 12 && preAuthCompSuccess))) {
            return (
                <div className='sugestedNextSteps'>
                    <h3 style={{marginTop: '0'}}>Suggested Next Steps:</h3>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center' }}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 13, featureId: _MCP})}>Purchase Correction</span>
                    </div>
                </div>
            );
        }

        if(prevSuccStep === selectedResponse && (selectedResponse === 8 && preAuthSuccess)) {
            return (
                <div className='sugestedNextSteps'>
                    <h3 style={{marginTop: '0'}}>Suggested Next Steps:</h3>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center' }}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 12, featureId: _MCP})}>Pre-Auth Completion</span>
                    </div>
                </div>
            );
        }
    }

    renderRightSide() {
        const { selectResponse, toggleResponsesList, isResponsesListOpen, selectedResponse, mode } = this.props;
        if(mode === 'interactive_tool') {
            return (
                    <div className="rightContainer">
                        <ResponseList
                            isOpen={isResponsesListOpen}
                            selection={selectedResponse}
                            responses={responses.filter((response) => this.props.history.includes(response.id))}
                            toggleResponseList={toggleResponsesList}
                            selectResponse={selectResponse}
                            featureId={_MCP}
                        />
                        <div className="rightContents">
                            {this.renderResponseContent()}
                            {this.renderNextSteps()}
                        </div>
                    </div>
            );
        }
    }

    renderLeftSide() {
        const { selectedStep, selectStep, toggleStepsList, isStepsListOpen, mode } = this.props;
        const steps = FEATURES.mcp.steps;

        if(mode === 'interactive_tool') {
            return (
                <div className='leftContainer'>
                    <StepsList 
                        isOpen={isStepsListOpen}
                        selection={selectedStep} 
                        toggleStepsList={toggleStepsList} 
                        steps={steps.filter((step) => ![1, 2, 17, 18, 19].includes(step.id))} //only interactive steps
                        selectStep={selectStep}
                        featureId={_MCP}
                    />
                    {this.renderStepsContent()}
                </div>
            );
        }
        else {
            return (
                <div className='documentContainer' onWheel={() => this.handleScrolling()}>
                    <StepsMenu 
                        selectStep={selectStep}
                        selection={selectedStep}
                        steps={steps}
                        featureId={_MCP}
                        scrollIntoStep={(stepId) => this.scrollIntoStep(stepId)}
                    />
                    {this.renderStepsContent()}
                </div>
            );
        }
    }

    renderUpArrow() {
        if(this.props.mode === 'integration_guide') {
            if(isIE) {
                return (
                    <div style={{ marginLeft: '42vw', marginTop: '55vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else if(isSafari) {
                return (
                    <div style={{ marginLeft: '45vw', marginTop: '30vh', paddingBottom: '1vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else {
                if(navigator.platform === "Win32") {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#129093;</span>
                        </div>
                    );
                }
                else {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#8679;</span>
                        </div>
                    );
                }
            }
        }
    }    


    render() {
        const { selectedStep, selectStep, history } = this.props;

        return (
            <div className="desktop">
                <Indicator 
                    title="Multi-Currency Pricing (MCP)"
                    steps={FEATURES.mcp.steps}
                    renderConfig={() => <Configuration />}
                    selection={selectedStep}
                    selectStep={selectStep}
                    isInteractive={() => ![1, 2, 17, 18, 19].includes(selectedStep)}
                    history={history}
                />
                
                <div className="mainContainer">
                    {this.renderLeftSide()}
                    {this.renderRightSide()}
                    {this.renderUpArrow()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const selectedStep = state.mcp.stepsList.selection;
    const isStepsListOpen = state.mcp.stepsList.isOpen;
    const selectedResponse = state.mcp.responseList.selection;
    const isResponsesListOpen = state.mcp.responseList.isOpen;
    const { mode } = state.common.sideNav;

    const { prevSuccStep, loading, getRateSuccess ,purchaseSuccess, preAuthSuccess, 
            preAuthCompSuccess, purchaseCorrectionSuccess, refundSuccess, history, mcpErrorCode,
            independentRefundSuccess, purchaseWithVaultSuccess, indRefundWithVaultSuccess,
            purchase3dsSuccess, purchase3dsVaultSuccess, preAuth3dsSuccess, preAuth3dsVaultSuccess
        } = state.mcp.main;

    const { getRateResponse ,purchaseResponse, preAuthResponse, preAuthCompResponse, 
            purchaseCorrectionResponse, refundResponse, independentRefundResponse,
            purchaseWithVaultResponse, preAuthWithVaultResponse, indRefundWithVaultResponse,
            purchase3dsResponse, purchase3dsVaultResponse, preAuth3dsResponse, preAuth3dsVaultResponse
        } = state.mcp.main;

    return {selectedStep, isStepsListOpen, selectedResponse, isResponsesListOpen, history,
            prevSuccStep, mode, purchaseResponse, loading, getRateSuccess ,purchaseSuccess, preAuthResponse, 
            preAuthSuccess, preAuthCompSuccess, purchaseCorrectionSuccess, refundSuccess, getRateResponse,
            independentRefundSuccess, purchaseWithVaultSuccess, indRefundWithVaultSuccess, preAuthCompResponse,
            purchaseCorrectionResponse, refundResponse, independentRefundResponse, mcpErrorCode,
            purchaseWithVaultResponse, preAuthWithVaultResponse, indRefundWithVaultResponse,
            purchase3dsSuccess, purchase3dsVaultSuccess, preAuth3dsSuccess, preAuth3dsVaultSuccess,
            purchase3dsResponse, purchase3dsVaultResponse, preAuth3dsResponse, preAuth3dsVaultResponse
        };
}

export default connect(mapStateToProps, {selectStep, selectMode, toggleStepsList, toggleResponsesList, selectResponse, selectFeature})(MCPPage);
